angular.module('component.bulkActions')
  .component('optionsUsed', {
    templateUrl: 'app/components/bulk-actions/components/options-used.html',
    controller: ['$translate', function($translate) {
      var ctrl = this;

      function update(options) {
        if (_.isUndefined(options) || _.isEmpty(options) || !options) {
          return;
        }

        var readableState = {
          true: $translate.instant('Yes'),
          false: $translate.instant('No')
        };
        var dryrunReadableState = {
          true: $translate.instant('Mock run'),
          false: $translate.instant('Real run')
        };
        var actionReadableState = {
          createOnlyIfNotExists: $translate.instant(
            'Search for existing data, create new records' +
            ' which do not exist, do not update existing data'
          ),
          forceCreate: $translate.instant(
            'Create all records in the file,' +
            ' do not check for existing data'
          ),
          createOrUpdate: $translate.instant(
            'Search for existing data, create new records' +
            ' which do not exist, update existing data'
          ),
          updateOnly: $translate.instant(
            'Search for existing data,' +
            ' do not create new records, update existing data'
          )
        };

        var linkExistingEventsToTargets =
          options.linkExistingEventsToTargets || false;
        ctrl.readableOptions = {};
        ctrl.readableOptions[$translate.instant('Action')] =
          actionReadableState[options.action];
        ctrl.readableOptions[$translate.instant('Type of bulk action')] =
          dryrunReadableState[options.dryrun];
        ctrl.readableOptions[$translate.instant('Email notifications')] =
          readableState[options.sendEmails];
        ctrl.readableOptions[
          $translate.instant('Link existing events to targets')
        ] = readableState[linkExistingEventsToTargets];
      }

      this.$onInit = function() {
        update(ctrl.options);
      };

      this.$onChanges = function(changes) {
        update(changes.options.currentValue);
      };
    }],
    bindings: {
      options: '<'
    }
  });
